module.exports = __webpack_public_path__ + "media/application/images/svgs/chrome-4cec59a1746b7f9379c8f883be0221df.svg";